import './HYouTube.scss';

import * as tsx from 'vue-tsx-support';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage, YouTubeModule } from '~/schemes';
import { HBackdrop } from '~/components';
import { extractYouTubeVideoId, getYoutubePoster } from '~/helpers';

export interface HYouTubeProps {
  value: ResolvedLanugageData<YouTubeModule['properties'], AvailableLanguage>;
}

export interface HYouTubeEmits {}

export interface HYouTubeScopedSlots {}

@Component<HYouTubeRef>({
  name: 'HYouTube',

  render() {
    const { videoUrl } = this.value;
    const { showVideo, youtubeVideoId, youtubePoster } = this;

    // SSR時は空のdivを返す（Hydration Mismatch回避）
    if (!process.client) {
      return <div staticClass="h-container h-youtube-module"></div>;
    }

    // videoUrlが存在しない場合（型安全性のため）
    if (!videoUrl || !youtubeVideoId) {
      return (
        <div staticClass="h-container h-youtube-module">
          {!videoUrl ? 'No YouTube URL provided' : 'Invalid YouTube URL'}
        </div>
      );
    }

    // YouTube埋め込みURL
    // rel=0: 関連動画を同チャンネルのみに制限
    // autoplay=1: 自動再生（mute=1とセットで使用）
    // mute=1: ミュート（自動再生に必要）
    const embedUrl = `https://www.youtube.com/embed/${youtubeVideoId}?rel=0&autoplay=1&mute=1`;

    return (
      <div staticClass="h-container h-youtube-module">
        {/* ポスター＋再生ボタン */}
        {!showVideo && (
          <div staticClass="h-youtube-module__button" onClick={this.toggle}>
            <div staticClass="h-youtube-module__thumbnail">
              <img
                src={youtubePoster}
                class="h-youtube-module__thumbnail__poster"
                alt="YouTube video thumbnail"
              />
              <img
                class="h-youtube-module__thumbnail__play-circle"
                src={this.$res.img('common/play_circle.svg')}
                alt="Play video"
              />
            </div>
          </div>
        )}

        {/* モーダルで動画表示 */}
        <HBackdrop
          v-model={this.showVideo}
          darken
          scopedSlots={{
            default: () => (
              <div staticClass="h-youtube-module__video">
                <iframe
                  src={showVideo ? embedUrl : ''}
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                />
              </div>
            ),
          }}
        />
      </div>
    );
  },
})
export class HYouTubeRef extends Vue implements HYouTubeProps {
  @Prop({ type: Object, required: true })
  readonly value!: ResolvedLanugageData<
    YouTubeModule['properties'],
    AvailableLanguage
  >;

  private showVideo = false;

  get youtubeVideoId(): string | null {
    return extractYouTubeVideoId(this.value.videoUrl);
  }

  get youtubePoster(): string {
    return getYoutubePoster(this.youtubeVideoId);
  }

  /** モーダルの表示切り替え */
  toggle() {
    this.showVideo = !this.showVideo;
  }
}

export const HYouTube = tsx
  .ofType<HYouTubeProps, HYouTubeEmits, HYouTubeScopedSlots>()
  .convert(HYouTubeRef);
